import {
  AfterContentInit, AfterViewInit, Component, ElementRef, Input, ViewChild,
  HostListener, EventEmitter, Output, OnInit
} from '@angular/core';
import { Config } from '../Config';
import { Observable, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})

export class NavMenuComponent implements OnInit, AfterViewInit {

  banner = '';
  isHomeActive = false;
  isConstructionActive = false;
  isTIPActive = false;
  isBridgeConditionsActive = false;
  shareLink = '';

  isMobileView = false;
  mobileTitle = '';
  isDropdownVisible = false;
  aoiSelected = false;
  rptName = 'Summary';
  userEmail = '';
  isValidEmail = true;
  processingEmail = false;
  emailCompleted = false;
  aoiDisplayName: string;
  rawSummaryReportData: ISummaryReportData[] = [];
  rawConditionReportData: IConditionReportData[] = [];
  invalidAOI = false;
  contactWidth = '800px';
  isMobileHome = false;

  public config = (window as any).config as Config;

  @ViewChild('contactWindow', { static: false }) private contactWindowRef: ElementRef<any>;
  @ViewChild('aboutWindow', { static: false }) private aboutWindowRef: ElementRef<any>;
  @ViewChild('deepLinkWindow', { static: false }) private deepLinkWindowRef: ElementRef<any>;
  @ViewChild('whatsNewWindow', { static: false }) private whatsNewWindowRef: ElementRef<any>;
  @ViewChild('streetViewWindow', { static: true }) private streetViewWindowRef: ElementRef<any>;
  @ViewChild('streetView', { static: true }) private streetViewRef: ElementRef<any>;
  @ViewChild('videoLogWindow', { static: true }) private videoLogWindowRef: ElementRef<any>;
  @ViewChild('videoLog', { static: true }) private videoLogRef: ElementRef<any>;
  @ViewChild('videoLogController', { static: true }) private videoLogControllerRef: ElementRef<any>;
  @ViewChild('shareWindow', { static: true }) private shareWindowRef: ElementRef<any>;
  @ViewChild('mobileEmailPromptWindow', { static: true }) private mobileEmailPromptWindowRef: ElementRef<any>;
  @ViewChild('mobileConstructionAboutWindow', { static: true }) private mobileConstructionAboutWindowRef: ElementRef<any>;
  @ViewChild('mobileTIPAboutWindow', { static: true }) private mobileTIPAboutWindowRef: ElementRef<any>;
  @ViewChild('mobileBridgeAboutWindow', { static: true }) private mobileBridgeAboutWindowRef: ElementRef<any>;
  @ViewChild('rmsSelect', { static: true }) private rmsSelectRef: ElementRef<any>;
  @ViewChild('latLongSelect', { static: true }) private latLongSelectRef: ElementRef<any>;

  private openVLSubscription: Subscription;
  @Input() openVL: Observable<{ countyCode: string, stateRouteNumber: string, segmentNumber: string, offset?: string | number }>;
  private openSVSubscription: Subscription;
  @Input() openSV: Observable<{ countyCode: string, stateRouteNumber: string, segmentNumber: string, offset?: string | number }>;
  private openSWSubscription: Subscription;
  @Input() openSW: Observable<any>;
  private aoiOpenedSubscription: Subscription;
  @Input() aoiGo: Observable<any>;
  private returnAOIInfoSubscription: Subscription;
  @Input() returnAOIInfo: Observable<any>;
  private openOMSubscription: Subscription;
  @Input() openOM: Observable<void>;

  @Output() openMapAOI: EventEmitter<void> = new EventEmitter();
  @Output() toggleMapLegend: EventEmitter<void> = new EventEmitter();
  @Output() getAOIInfo: EventEmitter<void> = new EventEmitter();
  @Output() openMapTour: EventEmitter<void> = new EventEmitter();

  constructor(private http: HttpClient) {
  }


  ngOnInit() {
    if (window.location.href.includes('?showMobile=true')) {
      this.isMobileView = true;
      this.contactWidth = '100%';

      if (window.location.href.includes('mobile-home')) {
        this.isMobileHome = true;
        this.mobileTitle = 'PA Transportation Projects';
      }
    }

    this.setNavbarHighlight();
  }

  ngAfterViewInit() {
    if (window.location.href.includes('map')) {
      this.openVLSubscription = this.openVL.subscribe((CRS) => {
        this.videoLogWindowRef.nativeElement.open();
        // wait for videolog to load it previous spot, then overwrite it with our parameters.
        setTimeout(() => {
          this.videoLogRef.nativeElement.setCrs(CRS);
        }, 750);
      });
      this.openSVSubscription = this.openSV.subscribe((CRS) => {
        this.streetViewWindowRef.nativeElement.open();
        setTimeout(() => {
          this.streetViewRef.nativeElement.setRms(CRS);
        }, 750);
      });
      this.streetViewWindowRef.nativeElement.addEventListener('openChange', open => {
        this.streetViewRef.nativeElement.active = open.detail;
      });
      this.openSWSubscription = this.openSW.subscribe((aoiLayer) => {
        this.openShareWindow(aoiLayer);
      });
      this.aoiOpenedSubscription = this.aoiGo.subscribe(() => {
        this.aoiSelected = true;
      });
      this.returnAOIInfoSubscription = this.returnAOIInfo.subscribe(async (aoiStr: string) => {
        if (aoiStr && !aoiStr.includes('aoiType=state')) {
          // parse String
          const params = aoiStr.substring(aoiStr.indexOf('&') + 1, aoiStr.length);
          let aoiType = params.substring(0, params.indexOf('='));
          let aoiValue = params.substring(params.indexOf('=') + 1, params.length);


          // reformate
          if (params.includes('dist=')) {
            aoiType = 'district';
            this.aoiDisplayName = 'District';
            const index = params.indexOf('dist=') + 'dist='.length;
            aoiValue = params.substring(index, index + 2);
          } else if (params.includes('cn=')) {
            if (params.includes('muni=')) {
              aoiType = 'municipality';
              this.aoiDisplayName = 'Municipality';
              let index = params.indexOf('cn=') + 'cn='.length;
              const countyValue = params.substring(index, index + 2);
              index = params.indexOf('muni=') + 'muni='.length;
              const muniValue = params.substring(index, params.length);
              aoiValue = countyValue + muniValue;
            } else {
              aoiType = 'county';
              this.aoiDisplayName = 'County';
              const index = params.indexOf('cn=') + 'cn='.length;
              aoiValue = params.substring(index, index + 2);
            }
          } else if (params.includes('houseDistrictNumber=')) {
            aoiType = 'houseDistrict';
            this.aoiDisplayName = 'Legislative House';
            const index = params.indexOf('houseDistrictNumber=') + 'houseDistrictNumber='.length;
            aoiValue = params.substring(index, params.length);
          } else if (params.includes('congressDistrictNumber=')) {
            aoiType = 'congressionalDistrict';
            this.aoiDisplayName = 'Legislative Congress';
            const index = params.indexOf('congressDistrictNumber=') + 'congressDistrictNumber='.length;
            aoiValue = params.substring(index, params.length);
          } else if (params.includes('senateDistrictNumber=')) {
            aoiType = 'senateDistrict';
            this.aoiDisplayName = 'Legislative Senate';
            const index = params.indexOf('senateDistrictNumber=') + 'senateDistrictNumber='.length;
            aoiValue = params.substring(index, params.length);
          } else if (params.includes('mporpo=')) {
            aoiType = 'planningPartner';
            this.aoiDisplayName = 'Planning Partner';
            const index = params.indexOf('mporpo=') + 'mporpo='.length;
            aoiValue = params.substring(index, params.length);
          } else {
            // aoi type not viable for report
            this.invalidAOI = true;
          }

          this.sendEmailReport(aoiType, aoiValue);
        } else {
          // aoi type not viable for report
          this.invalidAOI = true;
          this.processingEmail = false;
        }
      });
      this.openOMSubscription = this.openOM.subscribe(() => {
        const optionsMenuElement = document.getElementById('options-menu');
        if (optionsMenuElement) {
          optionsMenuElement.classList.toggle('active');
        }
      });

      this.streetViewRef.nativeElement.addEventListener('positionChange', (position) => {
        this.latLongSelectRef.nativeElement.setAttribute('lat', position.detail.latitude);
        this.latLongSelectRef.nativeElement.setAttribute('long', position.detail.longitude);
        this.rmsSelectRef.nativeElement.position = position.detail;
      });

      this.latLongSelectRef.nativeElement.addEventListener('latChange', (lat) => {
        this.streetViewRef.nativeElement.setAttribute('lat', lat.detail);
      });

      this.latLongSelectRef.nativeElement.addEventListener('longChange', (long) => {
        this.streetViewRef.nativeElement.setAttribute('long', long.detail);
      });

      // Create Listeners for options menu
      const menuToggle = document.getElementById('menu-toggle');
      const optionsMenu = document.getElementById('options-menu');
      const overlay = document.getElementById('overlay');
      const mapsMenu = document.getElementById('map-menu');

      // Toggle menu and overlay
      if (menuToggle) {
        menuToggle.addEventListener('click', () => {
          if (optionsMenu) {
            optionsMenu.classList.toggle('active');
          }
          if (overlay) {
            overlay.classList.toggle('active');
          }

          if (mapsMenu && mapsMenu.classList.contains('active')) {
            mapsMenu.classList.toggle('active');
            this.isDropdownVisible = false;
          }
        });
      }
      // Close menu when clicking on the overlay
      if (overlay) {
        overlay.addEventListener('click', () => {
          if (optionsMenu) {
            optionsMenu.classList.remove('active');
          }
          if (overlay) {
            overlay.classList.remove('active');
          }
        });
      }
    }
  }

  setNavbarHighlight() {
    this.isHomeActive = false;
    this.isConstructionActive = false;
    this.isTIPActive = false;
    this.isBridgeConditionsActive = false;

    if (window.location.href.includes('construction')) {
      this.isConstructionActive = true;
      this.banner = 'constructionAppLogo';
      this.mobileTitle = 'Road & Bridge Project Construction';
      this.rptName = 'Summary';
    } else if (window.location.href.includes('tip')) {
      this.isTIPActive = true;
      this.banner = 'TIPAppLogo';
      this.mobileTitle = 'Transportation Improvement Program';
      this.rptName = 'Summary';
    } else if (window.location.href.includes('bridge-conditions')) {
      this.isBridgeConditionsActive = true;
      this.banner = 'bridgeConditionsAppLogo';
      this.mobileTitle = 'Bridge Conditions';
      this.rptName = 'Condition';
    } else {
      this.isHomeActive = true;
      this.banner = 'projectsAppLogo';
    }
  }

  openContactWindow() {
    this.contactWindowRef.nativeElement.open();

    if (this.isMobileView) {
      this.closeOptionsMenu();
    }
  }
  closeContactWindow() {
    this.contactWindowRef.nativeElement.close();
  }
  openAboutWindow() {
    this.aboutWindowRef.nativeElement.open();
  }
  closeAboutWindow() {
    this.aboutWindowRef.nativeElement.close();
  }
  openDeepLinkWindow() {
    this.closeAboutWindow();
    this.deepLinkWindowRef.nativeElement.open();
  }
  closeDeepLinkWindow() {
    this.deepLinkWindowRef.nativeElement.close();
  }
  openWhatsNewWindow() {
    this.closeAboutWindow();
    this.whatsNewWindowRef.nativeElement.open();
  }
  closeWhatsNewWindow() {
    this.whatsNewWindowRef.nativeElement.close();
  }
  openShareWindow(aoiLayer) {
    this.shareLink = this.generateShareURL(aoiLayer);
    this.shareWindowRef.nativeElement.open();
  }
  closeShareWindow() {
    this.shareWindowRef.nativeElement.close();
  }

  generateShareURL(aoiLayer: any): string {
    let shareStr = this.config.url;
    if (this.isConstructionActive) {
      shareStr += 'construction-map';
    } else if (this.isTIPActive) {
      shareStr += 'tip-vis-map';
    } else if (this.isBridgeConditionsActive) {
      shareStr += 'bridge-conditions-map';
    }

    if (aoiLayer.length && aoiLayer[0].mapcoreProps && aoiLayer[0].mapcoreProps.query) {
      const selectedAOIQuery: {
        subqueries?: { field: string, operator: string, value: string, subqueries?: any[] }[],
        field: string,
        operator: string,
        value: string
      } = aoiLayer[0].mapcoreProps.query.subqueries[0];

      if (!selectedAOIQuery.subqueries) {
        if (selectedAOIQuery.field === 'COUNTY_NUMBER') {
          shareStr += '?cn=' + selectedAOIQuery.value;
        } else if (selectedAOIQuery.field === 'DISTRICT_NUMBER') {
          shareStr += '?dist=' + selectedAOIQuery.value;
        } else if (selectedAOIQuery.field === 'PLN_PRTNR_SHRTNM') {
          shareStr += '?mporpo=' + selectedAOIQuery.value;
        } else if (selectedAOIQuery.field === 'LEG_DISTRICT_NO') {
          if (aoiLayer[0].mapcoreProps.name.toLowerCase().includes('house')) {
            shareStr += '?houseDistrictNumber=' + selectedAOIQuery.value;
          } else if (aoiLayer[0].mapcoreProps.name.toLowerCase().includes('senate')) {
            shareStr += '?senateDistrictNumber=' + selectedAOIQuery.value;
          } else if (aoiLayer[0].mapcoreProps.name.toLowerCase().includes('congressional')) {
            shareStr += '?congressDistrictNumber=' + selectedAOIQuery.value;
          }
        }
      } else {
        shareStr += '?';
        let count = 0;
        for (const query of selectedAOIQuery.subqueries) {
          if (count > 0) {
            shareStr += '&';
          }

          if (query.field.toUpperCase() === 'CTY_CODE' || query.field.toUpperCase() === 'COUNTY') {
            shareStr += 'cn=' + query.value;
          } else if (query.field.toUpperCase() === 'ST_RT_NO') {
            shareStr += 'rt=' + query.value;
          } else if (query.field.toUpperCase() === 'SEG_NO' && query.operator === '>=') {
            shareStr += 'sg=' + query.value;
          } else if (query.field.toUpperCase() === 'SEG_NO' && query.operator === '<=') {
            shareStr += 'sgend=' + query.value;
          } else if (query.field.toUpperCase() === 'MUNICIPAL_CODE') {
            shareStr += 'muni=' + query.value;
          } else {
            count--;
          }

          count++;
        }
      }
    } else if (aoiLayer.length && aoiLayer[0].mapcoreProps && aoiLayer[0].mapcoreProps.name && aoiLayer[0].mapcoreProps.name.startsWith('AOI - ')) {
      // address aoi
      let addr: string = aoiLayer[0].mapcoreProps.name.substring('AOI - '.length, aoiLayer[0].mapcoreProps.name.length);
      addr = addr.replace(/\s/g, '%20');
      shareStr += '?address=' + addr;
    }

    return shareStr;
  }


  toggleDropdown(event: MouseEvent): void {
    // Toggles the visibility of the dropdown menu
    event.preventDefault();
    const mapsMenu = document.getElementById('map-menu');
    if (mapsMenu) {
      mapsMenu.classList.toggle('active');
    }

    this.closeOptionsMenu();

    if (!this.isDropdownVisible) {
      this.isDropdownVisible = true;
    } else {
      // setTimeout(() => {
      this.isDropdownVisible = false;
      // }, 400);
    }

  }

  // Listen for clicks on the entire document
  @HostListener('document:click', ['$event.target'])
  onClickOutside(targetElement: HTMLElement): void {
    // Close the dropdown if the click is outside the mobile nav area
    if (!targetElement.closest('.mobile-nav')) {
      this.isDropdownVisible = false;
    }
  }

  closeOptionsMenu() {
    // hide options menu if it is open to prevent overlap
    const optionsMenu = document.getElementById('options-menu');
    const overlay = document.getElementById('overlay');
    if (optionsMenu && optionsMenu.classList.contains('active')) {
      optionsMenu.classList.toggle('active');
    }
    if (overlay && overlay.classList.contains('active')) {
      overlay.classList.toggle('active');
    }
  }

  openAOI() {
    this.openMapAOI.emit();
    this.closeOptionsMenu();
  }

  toggleLegend() {
    this.toggleMapLegend.emit();
    this.closeOptionsMenu();
  }

  // Prompt User for their email
  openEmailReportPrompt() {
    // reset userEmail
    this.userEmail = '';
    this.mobileEmailPromptWindowRef.nativeElement.open();
    this.emailCompleted = false;
    this.isValidEmail = true;
    this.invalidAOI = false;
    this.closeOptionsMenu();
  }

  closeMobileEmailPromptWindow() {
    this.mobileEmailPromptWindowRef.nativeElement.close();
  }

  preprocessEmail() {
    // Verify email input field
    this.verifyUserEmail();
    if (this.isValidEmail) {
      // Show Loading message
      this.processingEmail = true;

      // Get AOI type
      this.getAOIInfo.emit();
    }
  }

  async sendEmailReport(aoiType: string, aoiValue: string) {
    let requestURL = 'api/reports/';

    if (aoiType === 'houseDistrict') {
      aoiType = 'legislativehouse';
    } else if (aoiType === 'senateDistrict') {
      aoiType = 'legislativesenate';
    } else if (aoiType === 'congressionalDistrict') {
      aoiType = 'legislativecongress';
    }

    if (this.isConstructionActive) {
      requestURL += 'GetConstructionReportData?aoiType=' + aoiType + '&aoiValue=' + aoiValue;
    } else if (this.isTIPActive) {
      requestURL += 'GetTIPVisReportData?aoiType=' + aoiType + '&aoiValue=' + aoiValue;
    } else if (this.isBridgeConditionsActive) {
      requestURL += 'GetBridgeConditionsReportData?aoiType=' + aoiType + '&aoiValue=' + aoiValue;
    }



    if (this.isConstructionActive || this.isTIPActive) {
      try {
        this.rawSummaryReportData = await this.http.get<ISummaryReportData[]>(requestURL).toPromise();
        // console.log(this.rawSummaryReportData);
      } catch (error) {
        console.error('Error', error);
      } finally {
        // create excel doc
        const workbook: XLSX.WorkBook = XLSX.utils.book_new();
        let worksheet: XLSX.WorkSheet;
        let name = '';

        if (this.isConstructionActive) {
          name = 'SummaryReport_Construction_';
        } else if (this.isTIPActive) {
          name = 'SummaryReport_TIPVis_';
        }

        worksheet = XLSX.utils.json_to_sheet(this.rawSummaryReportData ? this.rawSummaryReportData : []);
        const wbName = (name + aoiType).substring(0, 31);
        XLSX.utils.book_append_sheet(workbook, worksheet, wbName);

        const currentDate: Date = new Date();
        const formattedDate: string = currentDate.toISOString().slice(0, 10).replace(/-/g, '_');
        const base64Data = XLSX.write(workbook, { bookType: 'xlsx', type: 'base64' });

        const emailRequestUrl = 'api/reports/SendReportEmail';
        const reportData = {
          email: this.userEmail,
          subject: this.config.environmentName + ' PAProjects Mobile Report',
          message: `**This is a generated email, please do not respond** <br>` +
            `Thank you for using PAProjects, your report is attached.`,
          fileName: name + this.aoiDisplayName + aoiValue + '_' + formattedDate + '.xlsx',
          fileBase64: base64Data,
        };

        // Send the POST request
        this.http.post(emailRequestUrl, reportData)
          .subscribe(response => {
            // console.log("Email sent successfully:", response);

            this.processingEmail = false;
            this.emailCompleted = true;
          }, error => {
            // console.error('Error sending email:', error);

            this.processingEmail = false;
            this.emailCompleted = true;
          });

      }
    } else if (this.isBridgeConditionsActive) {
      try {
        this.rawConditionReportData = await this.http.get<IConditionReportData[]>(requestURL).toPromise();
        console.log(this.rawConditionReportData);
      } catch (error) {
        console.error('Error', error);
      } finally {
        // create excel doc
        const workbook: XLSX.WorkBook = XLSX.utils.book_new();
        let worksheet: XLSX.WorkSheet;
        let name = '';

        if (this.isConstructionActive) {
          name = 'SummaryReport_Construction_';
        } else if (this.isTIPActive) {
          name = 'SummaryReport_TIPVis_';
        }

        worksheet = XLSX.utils.json_to_sheet(this.rawConditionReportData ? this.rawConditionReportData : []);
        const wbName = (name + aoiType).substring(0, 31);
        XLSX.utils.book_append_sheet(workbook, worksheet, wbName);

        const currentDate: Date = new Date();
        const formattedDate: string = currentDate.toISOString().slice(0, 10).replace(/-/g, '_');
        const base64Data = XLSX.write(workbook, { bookType: 'xlsx', type: 'base64' });

        const emailRequestUrl = 'api/reports/SendReportEmail';
        const reportData = {
          email: this.userEmail,
          subject: this.config.environmentName + ' PAProjects Mobile Report',
          message: `**This is a generated email, please do not respond** <br>` +
            `Thank you for using PAProjects, your report is attached.`,
          fileName: name + this.aoiDisplayName + aoiValue + '_' + formattedDate + '.xlsx',
          fileBase64: base64Data,
        };

        // Send the POST request
        this.http.post(emailRequestUrl, reportData)
          .subscribe(response => {
            // console.log("Email sent successfully:", response);

            this.processingEmail = false;
            this.emailCompleted = true;
          }, error => {
            // console.error('Error sending email:', error);

            this.processingEmail = false;
            this.emailCompleted = true;
          });

      }
    }

  }

  verifyUserEmail() {
    // Regular expression for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.isValidEmail = emailRegex.test(this.userEmail);
  }

  openAboutMap() {
    if (this.isConstructionActive) {
      this.mobileConstructionAboutWindowRef.nativeElement.open();
    } else if (this.isTIPActive) {
      this.mobileTIPAboutWindowRef.nativeElement.open();
    } else if (this.isBridgeConditionsActive) {
      this.mobileBridgeAboutWindowRef.nativeElement.open();
    }
    this.closeOptionsMenu();
  }

  triggerTour() {
    this.openMapTour.emit();
  }
}

interface ISummaryReportData {
  county: string;
  description: string;
  improvementType: string;
  parentProjectId: number;
  projectID: string;
  status: string;
  title: string;
  total: number;
  totalStr: string;
}

interface IConditionReportData {
  stateLocal: string;
  condition: string;
  brKey: number;
  bridgeId: string;
  countyName: string;
  municipalityName: string;
  location: string;
  facility: string;
  featInt: string;
  postStatusDescription: string;
  districtnumber: string;
  countyCode: string;
  houseDistricts: string;
  senateDistricts: string;
  congressDistricts: string;
  planningPartnerShortName: string;
  countyMunicipalityCodes: string;
  ownerDescription: string;
  bridgeLength: number;
  deckArea: number;
  mainSpans: number;
  mainMaterial: string;
  mainStructure: string;
  yearBuilt: string;
  postLimitWeight: number;
  postLimitCombo: number;
  deckRating: string;
  supRating: string;
  subRating: string;
  culvRating: string;
  adtTotal: number;
  stateRoute: string;
  categoryName: string;
}
